var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6095 14.7334C19.0264 16.1125 18.1143 17.3278 16.9529 18.2729C15.7916 19.2181 14.4164 19.8644 12.9476 20.1553C11.4788 20.4462 9.96109 20.3729 8.52717 19.9417C7.09325 19.5105 5.78678 18.7347 4.72197 17.682C3.65717 16.6293 2.86645 15.3317 2.41895 13.9028C1.97145 12.4739 1.8808 10.9572 2.15492 9.48513C2.42903 8.0131 3.05957 6.63063 3.99141 5.45858C4.92325 4.28653 6.12801 3.36059 7.50037 2.76172",
    stroke: "#8F9DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3346 11.1667C20.3346 9.96288 20.0975 8.77089 19.6369 7.65874C19.1762 6.54658 18.501 5.53606 17.6498 4.68485C16.7986 3.83365 15.7881 3.15844 14.6759 2.69777C13.5637 2.2371 12.3718 2 11.168 2V11.1667H20.3346Z",
    stroke: "#8F9DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.7236dfc6a4d5fbb186daac56c3eb4782.svg";
export { ForwardRef as ReactComponent };